<template>
    <a href="#" class="shipping__address__link" @click="open_select_address_modal = true" v-if="modelValue">
        تغییر آدرس
        <span class="icon-Chevron_left"></span>
    </a>
    <Modal ref="modal" size="lg" name="select_address" :open="open_select_address_modal" @onDismiss="open_select_address_modal = false">
        <ModalHeader>
            <span>انتخاب آدرس</span>
        </ModalHeader>
        <ModalBody>
            <ul :class="{loading: loading}">
                <li v-for="address in addresses">
                    <div class="shipping__address mb-3" :class="{selected: address.id == modelValue}">
                        <div class="shipping__address__content" @click="selectAddress(address)">
                            <div class="shipping__address__item-wrapper">
                                <div class="shipping__address__item">
                                    <span class="shipping__address__item__key">آدرس: </span>
                                    <span class="shipping__address__item__vakue">{{address.province.name}}، {{address.city.name}}، {{address.line}}</span>
                                </div>
                                <div class="shipping__address__item">
                                    <span class="shipping__address__item__key">کدپستی: </span>
                                    <span class="shipping__address__item__vakue">{{address.postalcode}}</span>
                                </div>
                                <div class="shipping__address__item">
                                    <span class="shipping__address__item__key">گیرنده: </span>
                                    <span class="shipping__address__item__vakue">{{address.name}}</span>
                                </div>
                                <div class="shipping__address__item" v-if="address.phone">
                                    <span class="shipping__address__item__key"> شماره ثابت:</span>
                                    <span class="shipping__address__item__vakue">{{address.phone}}</span>
                                </div>
                                <div class="shipping__address__item">
                                    <span class="shipping__address__item__key"> شماره همراه:</span>
                                    <span class="shipping__address__item__vakue">{{address.mobile}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="shipping__address__actions">
                            <button class="btn btn-sm btn-outline-secondary" type="button" @click="editAddress(address)"><i class="fa fa-edit"></i></button>
                            <button class="btn btn-sm btn-outline-danger" type="button" @click="deleteAddress(address)"><i class="fa fa-close"></i></button>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="shipping__address">
                        <a href="javascript:void(0)" @click="createAddress" style="font-size: 13px;">+ افزودن آدرس جدید</a>
                    </div>
                </li>
            </ul>
        </ModalBody>
    </Modal>
    <CreateAddress
        v-model:open="open_create_address_modal"
        @onDismiss="this.open_select_address_modal = true"
        @onCreate="addressCreated"
    />
    <EditAddress
        :address="editing_address"
        v-model:open="open_edit_address_modal"
        @onDismiss="this.open_select_address_modal = true"
        @onUpdate="addressUpdated"
    />
</template>

<script>
import {HasModalMixin} from "../general/HasModalMixin";
import CreateAddress from "./CreateAddress";
import EditAddress from "./EditAddress";

export default {
    components: {EditAddress, CreateAddress},
    mixins: [HasModalMixin],
    name: "SelectAddress",
    emits: ['update:modelValue', 'update:open_create', 'onDelete', 'onUpdate', 'onCreate'],
    props: ['modelValue', 'addresses', 'open_create'],
    data: () => ({
        loading: false,
        open_select_address_modal: false,
        open_create_address_modal: false,
        open_edit_address_modal: false,
        editing_address: null
    }),
    watch: {
        open_create() {
            if (this.open_create) {
                this.createAddress();
            }
        },
        open_create_address_modal() {
            if (!this.open_create_address_modal) {
                this.$emit('update:open_create', false);
            }
        }
    },
    methods: {
        selectAddress(address) {
            this.$emit('update:modelValue', address.id);
            this.$refs.modal.dismiss();
        },
        createAddress() {
            this.open_create_address_modal = true;
            this.$refs.modal.dismiss();
        },
        addressCreated(address) {
            this.$emit('onCreate', address);
            this.selectAddress(address);
        },
        addressUpdated(address) {
            this.$emit('onUpdate', address);
        },
        editAddress(address) {
            this.editing_address = address;
            this.open_edit_address_modal = true;
            this.$refs.modal.dismiss();
        },
        deleteAddress(address) {
            this.$swal({
                title: 'آیا مطمئن هستید؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'بله',
                cancelButtonText: 'خیر',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    const token = localStorage.getItem('_token');
                    let config = {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    };
                    this.axios.delete(this.route('api.profile.addresses.destroy', [address.id]), config).then(response => {
                        this.successToast('عملیات با موفقیت انجام شد.');
                        this.loading = false;
                        this.$emit('onDelete', address);
                    }).catch(error => {
                        this.errorToast('عملیات با خطا مواجه شد.');
                        this.loading = false;
                    });
                }
            });
        }
    },
}
</script>

<style scoped>
    .shipping__address{
        cursor: pointer;
    }
    .shipping__address:hover{
        border-color: #CCCCCC;
    }
    .shipping__address.selected{
        border-color: #25CED1;
    }
</style>
